import { ProjectUser } from '@monorepo/shared/apiClient/types';
import { MenuOption } from '@monorepo/shared/componentsV2/menus/Menu';
import { NO_PERMISSION_TOOLTIP } from './sharedUtils';

export function getNotificationSettingsAction(
  currentUser: ProjectUser,
  user: ProjectUser,
  canManageUsers: boolean,
): MenuOption {
  let notificationSettingsUrl = '';
  if (currentUser.userId === user.userId) {
    notificationSettingsUrl = '/dashboard/settings/notifications';
  } else if (canManageUsers) {
    notificationSettingsUrl = `/dashboard/user/${user.userId}/settings/notifications`;
  }

  return {
    displayName: 'Edit notification settings',
    onClick: () => {
      window.location.href = notificationSettingsUrl;
    },
    disabled: !notificationSettingsUrl,
    tooltip: notificationSettingsUrl ? '' : NO_PERMISSION_TOOLTIP,
  };
}
